import styled from "styled-components";

const itemHeightBig = "36px";
const itemHeightSmall = "28px";

const getItemHightSize = (small: boolean) =>
    small ? itemHeightSmall : itemHeightBig;

//${({ dropUp }) => getSelectListItemBorderRadius(dropUp)}

// border-bottom-left-radius: ${props => (props.last ? "10px" : "0px")};
// border-bottom-right-radius: ${props => (props.last ? "10px" : "0px")};

export const SelectImage = styled.img<{
    small: boolean;
}>`
  width: ${props => (props.small ? "18px" : "22px")};
  margin-right: ${props => (props.small ? "5px" : "7px")};;

  @media (max-width: 380px) {
    display: none;
  }
`;

export const SelectListItem = styled.div<{
    small: boolean;
    last: boolean;
    dropUp?: boolean;
}>`
  display: flex;
  min-height: ${props => getItemHightSize(props.small)};
  max-height: ${props => getItemHightSize(props.small)};
  align-items: center;
  padding-left: 10px;
  justify-content: flex-start;
  font-family: 'Montserrat',sans-serif;
  /*font-size: var(--font-extra-small);*/

  &:hover {
    background: #282831;
  }
`;

export const SelectListWrapper = styled.div<{
    small: boolean;
    open: boolean;
    dropUp: boolean;
}>`
  width: 100%;
  position: absolute;
  /*background: #454550;*/
  background: #494956;
  list-style: none;
  z-index: 3;

  border-top-left-radius: ${props => (props.dropUp ? "10px" : "0px")};
  border-top-right-radius: ${({ dropUp }) => (dropUp ? "10px" : "0px")};
  border-bottom-left-radius: ${({ dropUp }) => (dropUp ? "0px" : "10px")};
  border-bottom-right-radius: ${({ dropUp }) => (dropUp ? "0px" : "10px")};

  & > div:first-child {
    &:hover {
      border-top-left-radius: ${({ dropUp }) => (dropUp ? "10px" : "0px")};
      border-top-right-radius: ${({ dropUp }) => (dropUp ? "10px" : "0px")};
    }
  }

  & > div:last-child {
    &:hover {
      border-bottom-left-radius: ${({ dropUp }) => (dropUp ? "0px" : "10px")};
      border-bottom-right-radius: ${({ dropUp }) => (dropUp ? "0px" : "10px")};
    }
  }

  top: ${({ dropUp, small }) => {
        const size = getItemHightSize(small);
        if (dropUp) {
            return "calc((" + size + " * 2) * -1)";
        }

        return size;
    }};
`;

export const ItemStyled = styled.div`
  display: flex;
  align-items: center;
  padding-left: 10px;
  justify-content: flex-start;
`;

export const SelectCurrent = styled(ItemStyled) <{ small: boolean, open: boolean, enabled: boolean }>`
  min-height: ${props => getItemHightSize(props.small)};
  max-height: ${props => getItemHightSize(props.small)};
  font-family: 'Montserrat',sans-serif;
  font-size: ${props => (props.small ? "14px" : "16px")};
  padding-right: ${props => (props.small ? "25px" : "30px")};;
  letter-spacing: 0.5px;
  
  & > div {
    width: 100%;
    height: 100%;
    padding-left: 10px;
  }

  &:hover {
    background-color: ${props => (props.enabled ? (props.open ? "" : "#50505B") : "")};
    border-radius: ${props => (props.open ? "" : "10px")};
  }

  &::after {
    content: "";
    top: ${props => {
        if (props.small) {
            return props.open ? "10px" : "8px";
        }

        return props.open ? "15px" : "8px";
    }};
    right: ${props => (props.small ? "10px" : "10px")};
    border: solid #fff;
    padding: ${props => (props.small ? "3px" : "5px")};
    display: inline-block;
    position: absolute;
    border-width: 0 2px 2px 0;

    transform: rotate(${props => (props.open ? "225deg" : "45deg")});
    -webkit-transform: rotate(${props => (props.open ? "225deg" : "45deg")});

    transition: 0.5s;
  }
`;

const getSelectWrapperBorderRaius = (dropUp: boolean, open: boolean) => {
    if (dropUp) {
        return `
      border-top-left-radius: ${open ? "0px" : "10px"};
      border-top-right-radius: ${open ? "0px" : "10px"};
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
    `;
    }

    return `
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      border-bottom-left-radius: ${open ? "0px" : "10px"};
      border-bottom-right-radius: ${open ? "0px" : "10px"};
  `;
};


export const SelectWrapper = styled.div<{
    small: boolean;
    dropUp: boolean;
    open: boolean;
    ref: any;
    enabled: boolean;
    buySelect: boolean;
    eth: boolean;
}>`

  cursor: pointer;
  border: --var(border);
  box-shadow: var(--depth-shadow-small);
  z-index: 3;
  font-weight: 500;
  font-size: ${props => (props.small ? "13px" : "14px")};
  position: ${props => (props.buySelect ? "absolute" : "relative")};
  left: ${props => (props.buySelect ? "160px" : "unset")};
  top: ${props => ( props.buySelect ? (props.eth ? "-50px" : "-36px") : "unset")};
  min-width: ${props => (props.small ? "80px" : "95px")};
  min-height: ${props => getItemHightSize(props.small)};
  max-height: ${props => getItemHightSize(props.small)};
  background: ${props => (props.enabled ? "#44444e" : "var(--disabled)")};

  ${props => getSelectWrapperBorderRaius(props.dropUp, props.open)}

  /* border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-left-radius: ${props => (props.open ? "0px" : "10px")};
  border-bottom-right-radius: ${props => (props.open ? "0px" : "10px")}; */

  @media (max-width: 380px) {
    min-width: ${props => (props.small ? "60px" : "70px")};
  }
`;